import { render, staticRenderFns } from "./IndicacaoSelect.vue?vue&type=template&id=253f6850&"
import script from "./IndicacaoSelect.vue?vue&type=script&lang=js&"
export * from "./IndicacaoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports